<template>
  <div>
    <div class="desktop_profile">
      <main-profile-scholar :idScholar="id" />
    </div>
    <v-divider></v-divider>
    <div>
      <div>
        <v-tabs
          fixed-tabs
          slider-size="4"
          background-color="#edf1f0"
          v-model="tab"
          active-class="bolder"
          color="var(--g)"
        >
          <v-tab class="text-capitalize">Dashboard</v-tab>
          <v-tab class="text-capitalize">Contract</v-tab>
          <v-tab class="text-capitalize">Proposal</v-tab>
          <v-tab class="text-capitalize">Reports</v-tab>
          <v-tab class="text-capitalize">GPA</v-tab>
        </v-tabs>
      </div>
      <v-tabs-items v-model="tab" style="background: none">
        <v-tab-item class="pa-1">
          <dashboard-profile-scholar />
        </v-tab-item>
        <v-tab-item class="pa-1">
          <upload-contract />
        </v-tab-item>
        <v-tab-item class="pa-1">
          <profile-proposal-scholar />
        </v-tab-item>
        <v-tab-item class="pa-1">
          <profile-report-scholar :gender="gender" />
        </v-tab-item>
        <v-tab-item class="pa-1"> <profile-ip-scholar /></v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import mainProfileScholar from "../../components/profile/scholar/mainProfileScholar.vue";
import UploadContract from "./scholar/contract/uploadContract.vue";
import DashboardProfileScholar from "./scholar/dashboard/profileDashboardScholar.vue";
import ProfileIpScholar from "./scholar/ip/profileIpScholar.vue";
import ProfileProposalScholar from "./scholar/profileProposalScholar.vue";
import ProfileReportScholar from "./scholar/report/profileReportScholar.vue";
export default {
  computed: {
    ...mapState({
      profile: (state) => state.profile,
      id: (state) => state.id,
    }),
  },
  components: {
    mainProfileScholar,
    DashboardProfileScholar,
    ProfileIpScholar,
    ProfileProposalScholar,
    UploadContract,
    ProfileReportScholar,
  },
  data() {
    return {
      tab: null,
      gender: "",
    };
  },
  mounted() {
    let checker = setInterval(() => {
      if (this.profile) {
        this.fetchData();
        clearInterval(checker);
      }
    }, 300);
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `scholar?scholar_id=${this.profile.id}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.gender = data.gender;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
  },
};
</script>

<style scoped>
.bolder {
  font-weight: bold;
}
.desktop_profile {
  display: block;
}
@media (max-width: 724px) {
  .desktop_profile {
    display: none;
    overflow: hidden;
  }
}
</style>
